<template>
    <v-tooltip :top="top" :bottom="bottom" :left="left" :right="right" class="text-body-2">
        <template v-slot:activator="{ on }">
            <v-icon v-on="on"> info </v-icon>
        </template>
        <span v-text="message" />
        <slot />
    </v-tooltip>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'TooltipLabel',
})
export default class TooltipLabel extends Vue {
    @Prop({ default: undefined }) message: string;
    @Prop({ default: false }) left: boolean;
    @Prop({ default: false }) right: boolean;
    @Prop({ default: false }) top: boolean;
    @Prop({ default: false }) bottom: boolean;
}
</script>
